<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g fill="none" fill-rule="evenodd" transform="translate(1 1)"><circle cx="5.5" cy="5.5" r="5.5" stroke="#4A9BF9"/><path fill="#4A9BF9" fill-rule="nonzero" d="M5.895 8.556L5.895 5.798 8.556 5.798 8.556 5.125 5.895 5.125 5.895 2.444 5.105 2.444 5.105 5.125 2.444 5.125 2.444 5.798 5.105 5.798 5.105 8.556z"/></g></svg>
</template>

<script>
export default {
    name: 'create-event-icon'
}
</script>
